export { default as CampaignSaveModal } from './CampaignSaveModal';
export { default as CampaignEndModal } from './CampaignEndModal';

export const CAMPAIGN_MODAL_NAMES = {
  CampaignSaveModal: 'CampaignSaveModal',
  CampaignEndModal: 'CampaignEndModal',
};
